import { Navigate, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faUser, faBuilding, faCircleQuestion } from "@fortawesome/free-solid-svg-icons";

import axios from "axios";
import config from "../../config/config.json";
import { isUserLoggedin } from "../../utils/Common";
import "./Register.css";

const Register = () => {
  const [authenticated, setauthenticated] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const result = isUserLoggedin();
    result && result.data && setauthenticated(true);
  }, []);

  const [email, setEmail] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [site, setSite] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const submitSignUpForm = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage("");
    setSuccessMessage("");

    const bodyObj = {
      email: email,
      familyName: lastname,
      givenName: firstname,
      site: site,
    };

    try {
      const postInstance = axios.create();
      postInstance
        .post(config.api.url + "signup", JSON.stringify(bodyObj))
        .then((result) => {
          setIsLoading(false);
          
          if (result.status === 201 || result.status === 200) {
            setSuccessMessage("User created successfully! Please check your email for details. Redirecting...");
            setTimeout(() => {
              navigate("/newpassword?email=" + email);
            }, 3000);
          } else {
            setErrorMessage("Please check the information provided.");
          }
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("Error in signup", err);
          
          if (err.response && err.response.status === 403) {
            setErrorMessage("User already exists. An account with this email already exists.");
          } else if (err.response && err.response.data && err.response.data.message) {
            setErrorMessage(err.response.data.message);
          } else {
            setErrorMessage("Something went wrong. Please try again.");
          }
        });
    } catch (err) {
      setIsLoading(false);
      console.log("error in calling api", err);
      setErrorMessage("Something went wrong. Please try again.");
    }
  };

  if (authenticated) {
    return <Navigate replace to="/profile" />;
  }

  return (
    <div className="register-container">
      {/* Internet Explorer Warning */}
      <div className="px-3 pt-4 mt-4 d-none" id="iesection">
        <h5>
          <strong>Sorry!</strong> Internet Explorer is no longer Supported. 
          Please use Chrome, Safari, Firefox or Edge browser.
        </h5>
      </div>
      
      {/* Background Image with Overlay */}
      <div className="register-background">
        <div className="register-overlay"></div>
      </div>

      {/* Content Wrapper */}
      <div className="register-content">
        {/* Left Panel - Branding Info */}
        <div className="register-info-panel">
          <div className="register-brand-section">
            <div className="register-logo-container">
              <img
                src={require("../../asset/image/logos/trial-main-box-logo.png")}
                alt="SMi Trial Logo"
                className="register-brand-logo"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>
            
            <h1 className="register-main-title">
              SMi Trial<sup>&trade;</sup>
            </h1>
            <h2 className="register-subtitle">
              Protocol Compliance Management
            </h2>
            
            <div className="register-features">
              <div className="register-feature-badge">
                <span className="register-feature-icon">✓</span>
                <span>Real-time Protocol Tracking</span>
              </div>
              <div className="register-feature-badge">
                <span className="register-feature-icon">✓</span>
                <span>Comprehensive Reporting</span>
              </div>
              <div className="register-feature-badge">
                <span className="register-feature-icon">✓</span>
                <span>Regulatory Compliance</span>
              </div>
            </div>

            <div className="register-learn-more">
              <a 
                href="https://www.sciencemedia.com/trial" 
                target="_blank" 
                rel="noopener noreferrer"
                className="register-learn-more-btn"
              >
                Learn More About SMi Trial
              </a>
            </div>
          </div>

          <div className="register-footer">
            <p>&copy; {new Date().getFullYear()} Science Media. All Rights Reserved.</p>
            <div className="register-footer-links">
              <a href="https://sciencemedia.com/privacy" target="_blank" rel="noopener noreferrer">
                Privacy
              </a>
              <span>•</span>
              <a href="#" onClick={(e) => e.preventDefault()}>
                Terms
              </a>
            </div>
          </div>
        </div>

        {/* Right Panel - Form */}
        <div className="register-form-panel">
          <div className="register-form-card">
            <div className="register-form-header">
              <img
                src={require(`../../asset/image/logos/${config.site.logo}`)}
                alt="Logo"
                className="register-site-logo"
              />
              <h2 className="register-form-title">Create Account</h2>
              <p className="register-form-subtitle">
                Sign up to get started with SMi Trial
              </p>
            </div>

            <form onSubmit={submitSignUpForm} className="register-form">
              {errorMessage && (
                <div className="register-alert register-alert-error">
                  <span className="register-alert-icon">⚠</span>
                  <p>{errorMessage}</p>
                </div>
              )}

              {successMessage && (
                <div className="register-alert register-alert-success">
                  <span className="register-alert-icon">✓</span>
                  <p>{successMessage}</p>
                </div>
              )}

              <div className="register-form-group">
                <label htmlFor="firstnameInput" className="register-label">
                  First Name <span className="register-optional">(Optional)</span>
                </label>
                <div className="register-input-wrapper">
                  <FontAwesomeIcon icon={faUser} className="register-input-icon" />
                  <input
                    type="text"
                    id="firstnameInput"
                    value={firstname}
                    onChange={(e) => setFirstname(e.target.value)}
                    className="register-input"
                    placeholder="Enter your first name"
                    autoFocus
                    disabled={isLoading}
                  />
                </div>
              </div>

              <div className="register-form-group">
                <label htmlFor="lastnameInput" className="register-label">
                  Last Name <span className="register-optional">(Optional)</span>
                </label>
                <div className="register-input-wrapper">
                  <FontAwesomeIcon icon={faUser} className="register-input-icon" />
                  <input
                    type="text"
                    id="lastnameInput"
                    value={lastname}
                    onChange={(e) => setLastname(e.target.value)}
                    className="register-input"
                    placeholder="Enter your last name"
                    disabled={isLoading}
                  />
                </div>
              </div>

              <div className="register-form-group">
                <label htmlFor="emailInput" className="register-label">
                  Email Address
                </label>
                <div className="register-input-wrapper">
                  <FontAwesomeIcon icon={faEnvelope} className="register-input-icon" />
                  <input
                    type="email"
                    id="emailInput"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="register-input"
                    placeholder="Enter your email"
                    required
                    disabled={isLoading}
                  />
                </div>
              </div>

              <div className="register-form-group">
                <label htmlFor="siteInput" className="register-label">
                  Site <span className="register-optional">(Optional)</span>
                </label>
                <div className="register-input-wrapper">
                  <FontAwesomeIcon icon={faBuilding} className="register-input-icon" />
                  <input
                    type="text"
                    id="siteInput"
                    value={site}
                    onChange={(e) => setSite(e.target.value)}
                    className="register-input"
                    placeholder="Enter your site"
                    disabled={isLoading}
                  />
                </div>
              </div>

              <button
                type="submit"
                className={`register-submit-btn ${isLoading ? "register-loading" : ""}`}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="register-spinner"></span>
                    <span>Creating Account...</span>
                  </>
                ) : (
                  "Sign Up"
                )}
              </button>

              <div className="register-signin-link">
                <span>Already have an account? </span>
                <a href="/login" className="register-link">
                  Sign In
                </a>
              </div>
            </form>

            <div className="register-help-section">
              <FontAwesomeIcon icon={faCircleQuestion} />
              <span>Need help? </span>
              <a href="mailto:help@smitrial.com" className="register-help-link">
                Contact Support
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
